<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'app',
    components: {

    },
    beforeCreate() {
      document.title = this.$route.meta.title
    },
    watch: {
      '$route': function (newValue) {
        document.title = this.$route.meta.title
      },
    },
    methods: {
      setTitle() {
        document.title = this.$route.meta.title
      },
      setHtmlFontSize () { //动态设置rem  1rem = 10px
        const htmlDom = document.getElementsByTagName('html')[0];
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if (htmlWidth >= 750) {
          htmlWidth = 750;
        }
        if (htmlWidth <= 320) {
          htmlWidth = 320;
        }
        htmlDom.style.fontSize = `${htmlWidth / 75}px`;
      }
    },
    mounted() {
      window.onresize = this.setHtmlFontSize //动态修改rem
      this.setHtmlFontSize();
    },
    created() {
      this.$store.commit('getUserStorage') //获取缓存中的用户信息
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }
  html{
    background: #f2f2f2;
  }
  /*火狐不支持修改滚动条*/
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar{
    width: 8px;
    height: 8px;
    background-color: #F5F5F5;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
    /*background: -webkit-gradient(linear, 40% 0%, 75% 84%, from(#4D9C41), to(#19911D), color-stop(.6,#54DE5D));;*/
    background: #07838D;
    /*background-color: #555;*/
  }
</style>
